var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 168)",
    stroke: "#B0B0B0",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 46,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 40 L22 24 L32 34 L42 22 L58 40",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.e978bd72f8dc1c327df856fc8e2267a3.svg";
export { ForwardRef as ReactComponent };